export const ROAD_TYPE_OPTIONS = ["Хорошая", "Нормальная", "Зависит от погоды", "Плохая", "Пешком"];
export const BANK_TYPE_OPTIONS = ["Дамба", "Ровный", "Небольшой уклон", "Сильный уклон", "Ломаный рельеф"];
export const CURRENT_STRENGTH_OPTIONS = ["Нет", "Слабое", "Среднее", "Сильное"];

export const NEW_SPOT_DRAFT_STORAGE_KEY = "new-spot-page-draft-v1";

export const STEP_TITLES_BY_MODE = {
    create: ["Локация", "Информация", "Рыба", "Фото", "Маршрут", "Отчёт"],
    editSuggestion: ["Информация", "Рыба", "Фото", "Маршрут"],
};
